var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16797 6.66663L8.26586 10.1791C8.88181 10.7071 9.18979 10.971 9.53519 11.0717C9.8396 11.1603 10.163 11.1603 10.4674 11.0717C10.8128 10.971 11.1208 10.7071 11.7367 10.1791L15.8346 6.66663",
    stroke: "#202635",
    strokeWidth: 0.833333,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 12.0834L15.8333 14.1667",
    stroke: "#202635",
    strokeWidth: 0.833333,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16797 14.1666L6.2513 12.0833",
    stroke: "#202635",
    strokeWidth: 0.833333,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08464 6.83329C2.08464 6.35971 2.08496 6.02958 2.10596 5.77256C2.12656 5.52041 2.16497 5.37554 2.22088 5.2658C2.34072 5.0306 2.53194 4.83938 2.76715 4.71953C2.87688 4.66362 3.02175 4.62522 3.2739 4.60462C3.53092 4.58362 3.86105 4.58329 4.33464 4.58329H15.668C16.1416 4.58329 16.4717 4.58362 16.7287 4.60462C16.9809 4.62522 17.1257 4.66362 17.2355 4.71953C17.4707 4.83938 17.6619 5.0306 17.7817 5.2658L18.153 5.07664L17.7817 5.2658C17.8376 5.37554 17.876 5.52041 17.8966 5.77256C17.9176 6.02958 17.918 6.35971 17.918 6.83329V14C17.918 14.4735 17.9176 14.8037 17.8966 15.0607C17.876 15.3128 17.8376 15.4577 17.7817 15.5674C17.6619 15.8026 17.4707 15.9939 17.2355 16.1137C17.1257 16.1696 16.9809 16.208 16.7287 16.2286C16.4717 16.2496 16.1416 16.25 15.668 16.25H4.33464C3.86105 16.25 3.53092 16.2496 3.2739 16.2286C3.02175 16.208 2.87688 16.1696 2.76715 16.1137C2.53194 15.9939 2.34072 15.8026 2.22088 15.5674C2.16497 15.4577 2.12656 15.3128 2.10596 15.0607C2.08496 14.8037 2.08464 14.4735 2.08464 14V6.83329Z",
    stroke: "#202635",
    strokeWidth: 0.833333
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.b748a408.svg";
export { ForwardRef as ReactComponent };